var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamsOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.125,
    height: 21.876,
    viewBox: "0 0 33.125 21.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(-6.999 -15.489)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29098",
    "data-name": "Group 29098",
    transform: "translate(6.999 15.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ARC_424_",
    transform: "translate(0 15.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29079",
    "data-name": "Group 29079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65262",
    "data-name": "Path 65262",
    d: "M11.76,41.047a.673.673,0,0,1-.1-.007A13.144,13.144,0,0,1,7.35,39.628a.663.663,0,1,1,.624-1.17,11.779,11.779,0,0,0,3.879,1.27.663.663,0,0,1-.093,1.319Z",
    transform: "translate(-6.999 -38.381)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_423_",
    transform: "translate(27.702 15.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29080",
    "data-name": "Group 29080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65263",
    "data-name": "Path 65263",
    d: "M49.477,41.048a.663.663,0,0,1-.093-1.318,11.774,11.774,0,0,0,3.879-1.27.663.663,0,1,1,.624,1.17,13.144,13.144,0,0,1-4.315,1.412A.785.785,0,0,1,49.477,41.048Z",
    transform: "translate(-48.815 -38.382)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_422_",
    transform: "translate(20.772 8.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29081",
    "data-name": "Group 29081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65264",
    "data-name": "Path 65264",
    d: "M39.017,31.736a.662.662,0,0,1-.554-1.024,5.049,5.049,0,0,1,4.243-2.3.662.662,0,0,1,0,1.325,3.726,3.726,0,0,0-3.133,1.7A.661.661,0,0,1,39.017,31.736Z",
    transform: "translate(-38.354 -28.412)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_38_",
    transform: "translate(22.26 1.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29082",
    "data-name": "Group 29082",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65265",
    "data-name": "Path 65265",
    d: "M44.932,26a4.331,4.331,0,1,1,4.331-4.331A4.389,4.389,0,0,1,44.932,26Zm0-7.338a3.006,3.006,0,1,0,3.006,3.006A3.047,3.047,0,0,0,44.932,18.661Z",
    transform: "translate(-40.6 -17.336)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_421_",
    transform: "translate(27.397 8.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29083",
    "data-name": "Group 29083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65266",
    "data-name": "Path 65266",
    d: "M53.419,34.141a.662.662,0,0,1-.662-.662,3.745,3.745,0,0,0-3.74-3.74.662.662,0,1,1,0-1.325,5.072,5.072,0,0,1,5.065,5.065A.662.662,0,0,1,53.419,34.141Z",
    transform: "translate(-48.354 -28.413)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_818_",
    transform: "translate(24.461 8.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29084",
    "data-name": "Group 29084",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65267",
    "data-name": "Path 65267",
    d: "M47.521,29.737H44.585a.662.662,0,0,1,0-1.325h2.935a.662.662,0,1,1,0,1.325Z",
    transform: "translate(-43.923 -28.412)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_817_",
    transform: "translate(31.8 12.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29085",
    "data-name": "Group 29085"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65268",
    "data-name": "Path 65268",
    d: "M55.662,38.585A.662.662,0,0,1,55,37.923v-2.2a.662.662,0,1,1,1.325,0v2.2A.662.662,0,0,1,55.662,38.585Z",
    transform: "translate(-55 -35.059)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_420_",
    transform: "translate(8.073 9.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29086",
    "data-name": "Group 29086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65269",
    "data-name": "Path 65269",
    d: "M19.847,37.454a.662.662,0,0,1-.662-.662,6.54,6.54,0,0,1,6.533-6.533.662.662,0,1,1,0,1.325,5.213,5.213,0,0,0-5.208,5.208A.662.662,0,0,1,19.847,37.454Z",
    transform: "translate(-19.185 -30.259)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_816_",
    transform: "translate(13.943 9.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29087",
    "data-name": "Group 29087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65270",
    "data-name": "Path 65270",
    d: "M32.622,31.584H28.708a.662.662,0,0,1,0-1.325h3.914a.662.662,0,0,1,0,1.325Z",
    transform: "translate(-28.046 -30.259)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_419_",
    transform: "translate(7.339 8.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29088",
    "data-name": "Group 29088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65271",
    "data-name": "Path 65271",
    d: "M22.429,31.736a.662.662,0,0,1-.556-.3,3.728,3.728,0,0,0-3.133-1.7.662.662,0,0,1,0-1.325,5.048,5.048,0,0,1,4.243,2.3.662.662,0,0,1-.554,1.024Z",
    transform: "translate(-18.078 -28.412)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_815_",
    transform: "translate(8.073 15.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29089",
    "data-name": "Group 29089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65272",
    "data-name": "Path 65272",
    d: "M19.847,43.38a.662.662,0,0,1-.662-.662V39.782a.662.662,0,1,1,1.325,0v2.935A.662.662,0,0,1,19.847,43.38Z",
    transform: "translate(-19.185 -39.12)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_37_",
    transform: "translate(11.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29090",
    "data-name": "Group 29090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65273",
    "data-name": "Path 65273",
    d: "M29.17,26.6a5.555,5.555,0,1,1,5.555-5.555A5.629,5.629,0,0,1,29.17,26.6Zm0-9.785a4.23,4.23,0,1,0,4.23,4.23A4.287,4.287,0,0,0,29.17,16.814Z",
    transform: "translate(-23.615 -15.489)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_418_",
    transform: "translate(17.857 9.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29091",
    "data-name": "Group 29091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65274",
    "data-name": "Path 65274",
    d: "M40.487,37.454a.662.662,0,0,1-.662-.662,5.213,5.213,0,0,0-5.208-5.208.662.662,0,1,1,0-1.325,6.54,6.54,0,0,1,6.533,6.533A.662.662,0,0,1,40.487,37.454Z",
    transform: "translate(-33.954 -30.259)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_814_",
    transform: "translate(23.727 15.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29092",
    "data-name": "Group 29092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65275",
    "data-name": "Path 65275",
    d: "M43.477,43.38a.662.662,0,0,1-.662-.662V39.782a.662.662,0,1,1,1.325,0v2.935A.662.662,0,0,1,43.477,43.38Z",
    transform: "translate(-42.815 -39.12)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_417_",
    transform: "translate(8.072 18.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29093",
    "data-name": "Group 29093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65276",
    "data-name": "Path 65276",
    d: "M27.674,46.837A17.287,17.287,0,0,1,19.535,44.8a.663.663,0,1,1,.624-1.17,15.943,15.943,0,0,0,15.031,0,.663.663,0,0,1,.624,1.17,17.3,17.3,0,0,1-8.14,2.038Z",
    transform: "translate(-19.184 -43.551)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_36_",
    transform: "translate(2.202 1.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29094",
    "data-name": "Group 29094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65277",
    "data-name": "Path 65277",
    d: "M14.654,26a4.331,4.331,0,1,1,4.331-4.331A4.389,4.389,0,0,1,14.654,26Zm0-7.338a3.006,3.006,0,1,0,3.006,3.006A3.046,3.046,0,0,0,14.654,18.661Z",
    transform: "translate(-10.323 -17.336)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_416_",
    transform: "translate(0.001 8.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29095",
    "data-name": "Group 29095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65278",
    "data-name": "Path 65278",
    d: "M7.662,34.141A.662.662,0,0,1,7,33.478a5.072,5.072,0,0,1,5.065-5.065.662.662,0,1,1,0,1.325,3.744,3.744,0,0,0-3.74,3.74A.662.662,0,0,1,7.662,34.141Z",
    transform: "translate(-7 -28.413)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_813_",
    transform: "translate(4.403 8.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29096",
    "data-name": "Group 29096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65279",
    "data-name": "Path 65279",
    d: "M17.244,29.737H14.308a.662.662,0,0,1,0-1.325h2.935a.662.662,0,0,1,0,1.325Z",
    transform: "translate(-13.646 -28.412)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_812_",
    transform: "translate(0.001 12.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29097",
    "data-name": "Group 29097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65280",
    "data-name": "Path 65280",
    d: "M7.662,38.585A.662.662,0,0,1,7,37.923v-2.2a.662.662,0,0,1,1.325,0v2.2A.662.662,0,0,1,7.662,38.585Z",
    transform: "translate(-7 -35.059)",
    fill: "currentColor"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsOutlined);
export default __webpack_public_path__ + "static/media/teams-outlined.5790a5f5d4fab2278e73dc912bfa9c69.svg";
export { ForwardRef as ReactComponent };